module.exports = __webpack_public_path__ + "static/media/02-banner-03-perisur-mobile@2x.df429f91.jpg";